/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, Output, EventEmitter} from "@angular/core";

declare var $: any;

@Component({
  selector: 'app-history-dialog',
  templateUrl: './history-dialog.component.html',
  styleUrls: ['./history-dialog.component.css']
})
export class HistoryDialogComponent {
  @Input() statusText = "";
  @Input() percentageDone = 0;
  @Input() okButtonEnabled = false;
  @Output() cancelHistory =new EventEmitter<boolean>();

  constructor() {

  }

  public show(): void {
    $("#historyDialog").modal("show");
  }

  public cancel(): void {
    this.cancelHistory.emit(true);
    this.hide();
  }

  public hide(): void {
    $("#historyDialog").modal("hide");
  }

}
